function StarwebStepOne() {
    return (
        <div>
            <h3 className="text-2xl font-semibold mb-8">
                Steg 1 -{" "}
                <span className="text-lg font-medium text-accent">
                    Inställningar
                </span>
            </h3>

            <div className="flex items-start">
                <div className="flex flex-col space-y-8 w-1/2">
                    <ul className="text-md font-medium list-disc list-outside pl-6 space-y-4">
                        <li>Logga in på ditt Starweb-konto.</li>
                        <li>Gå till "Inställningar" i den övre menyn.</li>
                        <li>Välj Starweb API.</li>
                        <li>
                            Öppna upp båda "Hantera API-klienter" och "Hanter
                            web hooks" i varsin ny flik.
                        </li>
                        <li>
                            När detta är gjort, öppna fliken för webhooken och
                            fortsätt till nästa steg nedan.
                        </li>
                    </ul>
                </div>

                <div className="ml-10 mr-10 space-y-6">
                    <img
                        src={`/images/extensions/starweb/settings.png`}
                        alt="Webhooks inställning"
                        className="object-contain w-[32rem] h-[32rem] max-w-3xl"
                    />
                </div>
            </div>
        </div>
    );
}
export default StarwebStepOne;
